import type { ReactNode } from 'react';

/* A ds StatCard figure with an optional caption beneath it: what the count
   covers when it is not the obvious whole ("of 120 loaded", "on this page").
   ds StatCard has no caption slot and its trend slot reads as a direction
   ("unchanged ..."), so the caption rides in the value, in body type. One KPI
   treatment across pages (design evaluation F46). */
export default function StatValue({ value, caption }: { value: ReactNode; caption?: ReactNode }) {
  return (
    <>
      {value}
      {caption ? (
        <span className="mt-0.5 block font-[family-name:var(--app-font-sans)] text-xs font-normal text-[var(--d2d-text-muted)]">
          {caption}
        </span>
      ) : null}
    </>
  );
}
